import { render, staticRenderFns } from "./BrowserRestrict.vue?vue&type=template&id=a1da601a&scoped=true"
import script from "./BrowserRestrict.vue?vue&type=script&lang=js"
export * from "./BrowserRestrict.vue?vue&type=script&lang=js"
import style0 from "./BrowserRestrict.vue?vue&type=style&index=0&id=a1da601a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1da601a",
  null
  
)

export default component.exports